<template>
  <v-autocomplete
    label="Comscore File"
    :filled="disabled"
    outlined
    :disabled="disabled"
    dense
    clearable
    :items="sortedOptions"
    item-text="Name"
    item-value="value"
    v-model="selected"
    @input="val => $emit('update', val)"
    :search-input.sync="search"
    return-object
    hide-details="true"
  >
  </v-autocomplete>
</template>

<script>
import { GET_DEMOS } from '@/appLogic/targets/createTarget/store/actions'
import { sortBy } from 'lodash'

export default {
  props: {
    value: null,
    size: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selected: this.initialValue || '',
      isLoading: false,
      isSelected: false,
      search: null,
      sortedOptions: [],
    }
  },
  beforeMount () {
    this.$store.dispatch(GET_DEMOS)
  },
  computed: {
    comscoreOptions () {
      let demos = this.$store.state.createTarget.demos
      let options = []
      demos.forEach(d => {
        options.push({Name: d.demo_name, value: d})
      })
      return options.sort((a, b) => {
        if (a.Name < b.Name) return -1
        if (a.Name > b.Name) return 1
        return 0
      })
    }
  },
  methods: {
    clear () {
      this.$refs.select.clear()
    }
  },
  watch: {
    search (val) {
      if (typeof val === 'string') {
        // Items have already been requested or selected
        if (this.isLoading || this.isSelected) return

        this.isLoading = true
        let sortedResults = sortBy(this.comscoreOptions, obj => obj.Name)
        this.sortedOptions = sortedResults
        this.isLoading = false
      }
    },
    comscoreOptions () {
      let sortedResults = sortBy(this.comscoreOptions, obj => obj.Name)
      this.sortedOptions = sortedResults
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// ComscoreSelect.vue?70a36e39